// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'caret-down';

export const Component = () => <path d='M21 8v2.75l-8.5 6.5-8.5-6.5V8l8.5 6.5z' />;

export const viewBox = '0 0 25 25';
